import { CloseCircle } from '@lamimed/pantheon';
import { Eye, Trash2 } from 'lucide-react';

import { InfoBox } from 'components/InfoBox';
import { ColumnRow } from 'components/InfoBox/containers/ColumnRow';

import * as S from './styles';

export interface FileBoxProps {
  id?: string;
  thumbUrl?: string;
  fileTitle?: string;
  filePosition?: number;
  maxFiles?: number;
  fileSize?: string;
  errorMessage?: string;
  format?: string;
  handleDelete?: (id: string) => void;
  handleView?: (id: string) => void;
  variant?: 'default' | 'view' | 'simple' | 'modalView';
}

export const FileBox = ({
  thumbUrl,
  fileTitle,
  filePosition,
  maxFiles,
  fileSize,
  errorMessage,
  handleDelete,
  handleView,
  variant = 'default',
  id,
  format,
}: FileBoxProps) => {
  const imageDescription = `${filePosition ? filePosition : ''}${
    maxFiles ? '/' + maxFiles : ''
  }${fileSize ? ' - ' + fileSize : ''}`;

  const wrapperLink =
    (variant === 'default' || variant === 'view') && handleView;

  return (
    <S.WrapperLink
      hasAction={!!wrapperLink}
      onClick={() => {
        if (wrapperLink) {
          id && handleView(id);
        }
      }}
    >
      <InfoBox
        borderColor={!errorMessage ? 'neutral_light' : 'state__error'}
        marginTop="none"
      >
        <ColumnRow
          head={
            <S.FileHead variant={variant}>
              {thumbUrl && (
                <S.ThumbWrapper $isError={!!errorMessage}>
                  <S.Thumb
                    src={thumbUrl}
                    width={36}
                    height={36}
                    alt={`${fileTitle}-thumb`}
                    quality={100}
                  />
                </S.ThumbWrapper>
              )}

              {errorMessage && !thumbUrl && <S.ThumbError />}

              <S.Text>
                <S.Row>
                  <S.SmallTypography
                    marginBottom="none"
                    variant="body_text_3"
                    color={errorMessage ? 'state__error' : 'text__primary'}
                    isEllipsis
                  >
                    {fileTitle}
                  </S.SmallTypography>

                  {format && (
                    <S.SmallTypography
                      marginBottom="none"
                      variant="body_text_3"
                      color={errorMessage ? 'state__error' : 'text__primary'}
                    >
                      .{format}
                    </S.SmallTypography>
                  )}
                </S.Row>

                <S.SmallTypography
                  color={errorMessage ? 'state__error' : 'neutral'}
                  marginBottom="none"
                >
                  {errorMessage ?? imageDescription}
                </S.SmallTypography>
              </S.Text>
            </S.FileHead>
          }
          icon={!errorMessage && variant === 'default' && <Eye />}
          marginBottom="none"
        >
          <S.FileContent variant={variant}>
            {variant === 'default' && (
              <S.Button
                variant="clear"
                shrinked
                onClick={(event) => {
                  event.preventDefault();

                  event.stopPropagation();

                  id && handleDelete?.(id);
                }}
              >
                <Trash2 />
              </S.Button>
            )}

            {variant === 'view' && <Eye />}

            {variant === 'modalView' && handleView && (
              <S.Button
                variant="clear"
                shrinked
                onClick={() => id && handleView(id)}
              >
                <CloseCircle width={20} height={20} color="dark" />
              </S.Button>
            )}
          </S.FileContent>
        </ColumnRow>
      </InfoBox>
    </S.WrapperLink>
  );
};
